import {ICorrespondantWebServiceClient} from "@resources/resources";
import {ActivatedRoute, Router} from "@angular/router";
import {Component} from "@angular/core";
import {CerbaCookieService, CookieConstantes, TagConstantes, CorrespondantStore} from "@digicerba/common";
import {PanierStore} from "@common/store/panier.store";

@Component({
  selector: 'menu-component',
  templateUrl: './menu.component.html',
  host: { 'class': 'menu' }
})
export class MenuComponent {

  correspondants = [];
  nombreArticles = 0;
  selectedValue = null;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private cookieService: CerbaCookieService, private panierStore: PanierStore,
              private correspondantWebServiceClient: ICorrespondantWebServiceClient, private correspondantStore: CorrespondantStore) {
  }

  ngOnInit() {
    this.correspondants = this.correspondantStore.getCorrespondants();
    this.selectedValue = this.correspondantStore.getCorrespondant();

    this.panierStore.getPanier().subscribe(panier => {
      if (panier) {
        this.nombreArticles = this.panierStore.countPanierArticles();
      }
    });
    this.panierStore.onPanierUpdate().subscribe(panier => {
      console.log("Update affichage nombres articles...");
      if (panier) {
        this.nombreArticles = this.panierStore.countPanierArticles();
      }
    });
  }

  onCorrespondantChange(newValue) {
    this.selectedValue = newValue;
    this.correspondantStore.setCorrespondant(newValue);
    this.cookieService.removeCoockie(CookieConstantes.COOKIE_CORRESPONDANT);
    this.cookieService.addCoockie(CookieConstantes.COOKIE_CORRESPONDANT, this.correspondantStore.getCorrespondant().code);
    window.location.reload(true);
  }

  reinitPreview() {
    this.panierStore.resetAffichageRecap();
  }

  isAdmin() {
    return this.correspondantStore.hasTag(TagConstantes.GESTIONNAIRE_CATALOGUE);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/menu/menu.component.ts